import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { AuthService } from '../service/auth.service';
import { EcomicService } from '../service/comics/ecomic.service';

declare const swal: any;
declare var $: any;

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.css']
})
export class OffersComponent implements OnInit {
  AllOffers = [];
  id: any;


  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private comicService: EcomicService,
    private route: ActivatedRoute, private auth: AuthService, public toastr: ToastsManager, vcr: ViewContainerRef,private http:HttpClient) {
    this.toastr.setRootViewContainerRef(vcr);
  }


  ngOnInit() {
    this.GetAllOffers();
  }
 async GetAllOffers(){
  try {

    const offers = await this.afs.collection(`Offers`, res => {
      return res.orderBy('createdAt',"desc");
    });
    const data = await offers.valueChanges();
    data.subscribe(async (response)=>{
      this.AllOffers = response;
      console.log(this.AllOffers)
    })
    
  } catch (error) {
    throw error;
  }
 }
 delete(id) {
  console.log(id);
  this.id = id;
  $("#DeleteModal").modal();
}
deletedata() {
  $('#DeleteModal').modal('hide');
      this.afs.doc('/Offers/'+this.id).delete().then(function () {  
        swal('Deleted!', 'Your List has been deleted.', 'success');
      }).catch(function(error){
        swal('Error!', error, 'error');
        console.error("error in removing document:",error);
      });
   
}
}



// WEBPACK FOOTER //
// ./src/app/offers/offers.component.ts